const states = [
  { label: "Andaman and Nicobar Islands", value: "ANDAMAN AND NICOBAR ISLANDS" },
  { label: "Andra Pradesh", value: "ANDHRA PRADESH" },
  { label: "Arunachal Pradesh", value: "ARUNACHAL PRADESH" },
  { label: "Assam", value: "ASSAM" },
  { label: "Bihar", value: "BIHAR" },
  { label: "Chhattisgarh", value: "CHHATTISGARH" },
  { label: "Dadra and Nagar Haveli", value: "DADRA AND NAGAR HAVELI" },
  { label: "Daman and Diu", value: "DAMAN AND DIU" },
  { label: "Delhi", value: "DELHI" },
  { label: "Goa", value: "GOA" },
  { label: "Himachal Pradesh", value: "HIMACHAL PRADESH" },
  { label: "Jammu and Kashmir", value: "JAMMU AND KASHMIR" },
  { label: "Jharkhand", value: "JHARKHAND" },
  { label: "Karnataka", value: "KARNATAKA" },
  { label: "Kerala", value: "KERALA" },
  { label: "Lakshadweep", value: "LAKSHADWEEP" },
  { label: "Maharashtra", value: "MAHARASHTRA" },
  { label: "Manipur", value: "MANIPUR" },
  { label: "Meghalaya", value: "MEGHALAYA" },
  { label: "Odisha", value: "ODISHA" },
  { label: "Puducherry", value: "PUDUCHERRY" },
  { label: "Rajasthan", value: "RAJASTHAN" },
  { label: "Sikkim", value: "SIKKIM" },
  { label: "Tamilnadu", value: "TAMILNADU" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "TRIPURA" },
  { label: "Uttar Pradesh", value: "UTTAR PRADESH" },
  { label: "West Bengal", value: "WEST BENGAL" },
  { label: "Others", value: "Others" },
];


export default states;
